import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate, NavLink } from "react-router-dom";
import {
    Grid,
    Container,
    Paper,
    Typography,
    Divider,
    IconButton,
    Icon,
} from "@mui/material";
import { Loading, Tabs, TabContainer, Tooltip } from "@gpstrackit/react-controls"
import { useIntl } from "react-intl";

//Actions
import {
    brandgetDataRequest,
    brandsEditBrandOpenModal,
    clearRedux,
} from "Redux/actions";

//Components
import ChipStatus from 'Components/ChipStatus';
import SummaryCard from 'Components/SummaryCard';
import MultiLevelSelector from "Components/SelectorMultiLevel";
//Tabs
import Activities from "Modules/activities/.components/tab";
import Dealers from "Modules/dealers/views/.components/tab";
import Packages from "Modules/packages/.components/tab";
import MessageTemplates from "Modules/brands/views/.components/messageTemplateTab";

//Views
import EditBrand from 'Modules/brands/views/.components/editBrand';

//Helpers
import { getDateFormatted, copyToClipboard } from 'Core/data/Helpers';
import { endpoints } from 'Core/defaultValues';
//Permission
import { HasPermission } from "Core/security"

const BrandOverview = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const navigate = useNavigate();

    const { loading, brand } = useSelector(state => state.brandOverviewRedux);
    const editBrandOModal = useSelector(state => state.editBrandRedux.openModal);
    const user = useSelector(state => state.securityRedux.user);

    const { id } = useParams();
    const [tab, setTab] = useState(0);
    const [openSummary, setOpenSummary] = useState(true);

    useEffect(() => {
        dispatch(brandgetDataRequest(id))
        return () => {
            dispatch(clearRedux("BRAND_OVERVIEW"));
            dispatch(clearRedux("COMMON", {
                'companies-tab': {},
                'packages-tab': {}
            }))
        }
    }, [])

    const SummaryItem = (props) => {
        const { label, value } = props;
        return (
            <Grid item xs={4} sm={4}>
                <div style={{ display: 'grid' }}>
                    <span style={{ opacity: 0.6 }} className="text-muted mb-2">
                        {label}
                    </span>
                    {
                        brand ? value() : <div style={{ width: 210, height: 20 }}></div>
                    }
                </div>
            </Grid>
        )
    }


    let activitiesTab = HasPermission(user, "act");
    let dealersTab = HasPermission(user, "dea");
    let messagesTemplatesTab = HasPermission(user, "mssgtmpt");

    let indexCount = 0;

    let innerHeight = window.innerHeight

    return (
        <Container maxWidth={false} className="container-view">
            {loading && <Loading overlay show />}
            <Paper elevation={0}>
                <Grid
                    container
                    direction="row"
                    style={{ padding: "14px 18px", borderBottom: "1px solid #e8e8e8" }}
                >
                    <Grid item xs={12} style={{ textAlign: 'left' }}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Grid item xs={6}>
                                <Typography variant="h5" component="div" style={{ display: 'flex', alignItems: 'center' }}>
                                    <IconButton onClick={() => navigate(-1)} size="large">
                                        <Icon style={{ cursor: "pointer" }} className="toolbar-list-icon">
                                            arrow_back
                                        </Icon>
                                    </IconButton>
                                    <span style={{ marginRight: 5, opacity: 0.6 }}>{messages['brand_overview_title']}:</span> {brand?.title ? `${brand.title?.substring(0, 30)} (${brand.id})` : ''}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} style={{ textAlign: 'end' }}>
                                <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                    <MultiLevelSelector
                                        label={messages['brand_overview_actions']}
                                        position="left"
                                        options={[
                                            {
                                                id: "edit_brand",
                                                label: messages['brand_overview_edit_brand'],
                                                show: true,
                                                action: () => {
                                                    dispatch(brandsEditBrandOpenModal(brand.id))
                                                },
                                                disabled: !HasPermission(user, "brnd", "u"),
                                            }
                                        ]}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider style={{ backgroundColor: '#999999' }} />
                            </Grid>
                        </Grid>
                        <SummaryCard
                            onChange={(value) => setOpenSummary(value)}
                            name="brands-summary"
                        >
                            <Grid container>
                                <SummaryItem
                                    label={messages['brand_overview_code']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {brand?.code}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['brand_overview_title']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {brand?.title}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['brand_overview_domains']}
                                    value={() => {
                                        let domains = brand?.domains;
                                        if (domains?.length > 0) {
                                            try {
                                                domains = JSON.parse(JSON.parse(domains));
                                                if (!Array.isArray(domains)) {
                                                    domains = JSON.parse(domains);
                                                }
                                            } catch (e) {
                                                console.log("Error parsing domains", e);
                                            }
                                        }
                                        if (domains?.length > 0) {
                                            return (
                                                <div style={{ display: 'flow', alignItems: 'center' }}>
                                                    <span >
                                                        {domains?.map((item, index) => {
                                                            return (
                                                                <a
                                                                    style={{ marginRight: 10, color: 'black', cursor: 'pointer', textDecoration: 'underline' }}
                                                                    onClick={(e) => {
                                                                        window.open(`https://${item}`, '_blank');
                                                                    }}
                                                                >
                                                                    {item}
                                                                </a>
                                                            )
                                                        })}
                                                    </span>
                                                </div>
                                            )
                                        } else {
                                            return <span></span>
                                        }
                                    }}
                                />

                            </Grid>
                        </SummaryCard>

                        <Tabs onChange={(numberTab) => { setTab(numberTab) }}>

                            {
                                dealersTab &&
                                <TabContainer index={indexCount++} key={`menu-${0}`} label={messages['brand_overview_tab_dealers']}>
                                    {brand?.id &&
                                        <Dealers
                                            tab={tab}
                                            brandId={id}
                                            height={openSummary ? innerHeight - 370 : innerHeight - 170}
                                            brand={brand}
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                activitiesTab &&
                                <TabContainer index={indexCount++} key={`menu-${1}`} label={messages['brand_overview_activities']}>
                                    {brand?.id &&
                                        <Activities
                                            tab={tab}
                                            entityName="Brand"
                                            entityId={id}
                                            height={openSummary ? innerHeight - 370 : innerHeight - 170}
                                            noFilters
                                            noOpenSearch
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                messagesTemplatesTab &&
                                <TabContainer index={indexCount++} key={`menu-${2}`} label={messages['brand_overview_tab_messages_templates']}>
                                    {brand?.id &&
                                        <MessageTemplates
                                            tab={tab}
                                            entityName="Brand"
                                            entityId={id}
                                            height={openSummary ? innerHeight - 370 : innerHeight - 170}
                                            paramBrand={brand}
                                        />
                                    }
                                </TabContainer>
                            }
                        </Tabs>
                    </Grid>
                </Grid>
            </Paper>
            {editBrandOModal && <EditBrand getBrand={() => dispatch(brandgetDataRequest(id))} />}

        </Container>
    );
}
export default BrandOverview;